module.exports = {
    global: {
        wowContactNumber: '1800 000 610',
        wowContactEmail: 'newshoponline@woolworths.com.au',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/global.js